import React from 'react';
import ReactPaginate from "react-paginate";
import PropTypes from "prop-types";


const PaginationUtil = ({handlePageClick,
                        totalPages}) => {

    return (
        <>
            <ReactPaginate
                breakLabel="..."
                className={"pagination pagination-sm"}
                pageClassName={"page-item"}
                activeClassName={"active"}
                activeLinkClassName={"page-item-active"}
                nextLabel="next >"
                onPageChange={handlePageClick}
                pageRangeDisplayed={2}
                pageCount={totalPages}
                previousLabel="< previous"
                renderOnZeroPageCount={null}
            />
        </>
    )
}

PaginationUtil.propType = {
    handlePageClick: PropTypes.func,
    totalPages: PropTypes.number
};

export default PaginationUtil;
